<template>
  <div ref="app" :class="['template03', { border: isBorder }]">
    <div class="text">
      <el-input
        v-model="contentData.title"
        :rows="2"
        resize="none"
        type="textarea"
        class="title"
      ></el-input>
      <el-input v-model="contentData.teacher" class="teacher"></el-input>
      <div class="content">
        <div v-for="(item, index) in contentData.content" :key="index" class="content-item">
          <el-input v-model="item.text" class="content-text"></el-input>
        </div>
      </div>
      <el-input v-model="contentData.date" class="date"></el-input>
      <div class="qrcode">
        <div class="code">
          <img :src="qrCode" alt="" />
        </div>
        <div class="des">
          <p>保存图片或用微信</p>
          <p>扫一扫识别二维码</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
export default {
  name: 'Template03',
  props: {
    qrCode: {
      type: String,
      default: '',
    },
    templateBackground: {
      type: String,
      default: '',
    },
    isBorder: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      contentData: {
        title: '企业如何\n做好生产与管理？',
        teacher: '某老师',
        content: [
          { text: '1.培训内容培训内容培训内容培训内容' },
          { text: '2.培训内容培训内容培训内容培训内容' },
          { text: '3.培训内容培训内容培训内容培训内容' },
          { text: '4.培训内容培训内容培训内容培训内容' },
        ],
        date: '2021.06.03 — 2021.06.06',
      },
    }
  },
  mounted() {
    this.$nextTick(() => {
      const $app = this.$refs.app
      const standardScale = 2208 / 1242
      window.addEventListener(
        'resize',
        _.debounce(() => {
          const docHeight = document.querySelector('.design-wrapper').clientHeight
          const docWidth = document.querySelector('.design-wrapper').clientWidth

          const currentScale = docHeight / docWidth
          let [scale, translate] = [0, 0]
          if (currentScale < standardScale) {
            // 以高度计算
            scale = docHeight / 2208
            const shouleWidth = 1242 * scale
            const offsetWidth = docWidth - shouleWidth
            translate = offsetWidth > 0 ? `translate(${offsetWidth / 2}px, 0)` : ''
          } else {
            // 以宽度计算
            scale = docWidth / 1242
            const shouleHeight = 2208 * scale
            const offsetHeight = docHeight - shouleHeight
            translate = offsetHeight > 0 ? `translate(0, ${offsetHeight / 2}px)` : ''
          }
          console.log(translate)
          // background:url(${this.templateBackground});
          $app.style.cssText = `
            transform: scale(${scale});
            min-width: 1242px;
            min-height: 2208px;
          `
        }),
        200,
      )

      if (document.createEvent) {
        var event = document.createEvent('HTMLEvents')
        event.initEvent('resize', true, true)
        window.dispatchEvent(event)
      } else if (document.createEventObject) {
        window.fireEvent('onresize')
      }
    })
  },
}
</script>
<style lang="scss" scoped>
@font-face {
  font-family: Alibaba-PuHuiTi-Bold;
  src: url('../../../../../font/Alibaba-PuHuiTi-Bold.otf');
}
@font-face {
  font-family: Source Han Sans CN-Medium;
  src: url('../../../../../font/SourceHanSansCN-Medium.otf');
}
@font-face {
  font-family: Source Han Sans CN-Regular;
  src: url('../../../../../font/SourceHanSansCN-Regular.otf');
}
.template03 {
  overflow: hidden;
  position: relative;
  min-width: 1242px;
  min-height: 2208px;
  background: url('../../../../../assets/posterTemplate/template03.png') no-repeat;
  background-size: 100% 100%;
  .text {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    ::v-deep.el-input {
      input {
        vertical-align: top;
        box-sizing: border-box;
        border: 0;
        border-radius: 0;
        height: auto;
        background-color: transparent;
        color: #ffffff;
      }
    }
    ::v-deep.el-textarea {
      textarea {
        box-sizing: border-box;
        border: 0;
        border-radius: 0;
        height: auto;
        background-color: transparent;
        color: #ffffff;
      }
    }
    ::v-deep.title {
      position: absolute;
      top: 153px;
      left: 50%;
      transform: translateX(-460px);
      display: block;
      width: 960px;
      textarea {
        padding: 0;
        height: 295px;
        font-size: 118px;
        box-sizing: border-box;
        font-family: Alibaba-PuHuiTi-Bold;
        font-weight: 700;
        line-height: 138px;
        overflow: hidden;
        text-align: center;
        color: #5649ed;
        &:focus {
          border: 2px dashed #ff7b33;
          border-radius: 0;
        }
      }
    }
    ::v-deep.teacher {
      position: absolute;
      top: 637px;
      left: 50%;
      transform: translateX(-50%);
      display: block;
      width: 400px;
      input {
        font-size: 60px;
        font-family: Source Han Sans CN-Medium;
        font-weight: 500;
        box-sizing: border-box;
        color: #001c66;
        text-align: center;
        &:focus {
          border: 2px dashed #ff7b33;
          border-radius: 0;
        }
      }
    }
    ::v-deep .content {
      position: absolute;
      top: 939px;
      left: 253px;
      .content-item {
        display: flex;
        align-items: center;
        margin-bottom: 55px;
        .content-text {
          width: 854px;
          input {
            height: 50px;
            box-sizing: border-box;
            font-size: 48px;
            font-family: Source Han Sans CN-Medium;
            font-weight: 500;
            color: #001c66;
            &:focus {
              border: 2px dashed #ff7b33;
              border-radius: 0;
            }
          }
        }
      }
    }
    ::v-deep.date {
      position: absolute;
      top: 1476px;
      left: 50%;
      transform: translateX(-50%);
      display: block;
      width: 600px;
      input {
        font-size: 48px;
        font-weight: 500;
        color: #4d41e3;
        text-align: center;
        font-family: Source Han Sans CN-Medium;
        &:focus {
          border: 2px dashed #ff7b33;
          border-radius: 0;
        }
      }
    }
    .qrcode {
      position: absolute;
      top: 1727px;
      left: 235px;
      display: flex;
      align-items: center;
      .code {
        width: 298px;
        height: 298px;
        background: #ffffff;
        border: 8px solid #2b65ff;
        border-radius: 10px;
        margin-right: 63px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .des {
        font-size: 52px;
        font-family: Source Han Sans CN-Medium;
        font-weight: 500;
        text-align: left;
        color: #333;
        line-height: 72px;
      }
    }
  }
  &.border {
    ::v-deep.el-input {
      input {
        border: 2px dashed #c9c9c9;
      }
    }
    ::v-deep.el-textarea {
      textarea {
        border: 2px dashed #c9c9c9;
      }
    }
  }
  img {
    height: 100%;
    -moz-user-select: none; /*火狐*/
    -webkit-user-select: none; /*webkit浏览器*/
    -ms-user-select: none; /*IE10*/
    -khtml-user-select: none; /*早期浏览器*/
    user-select: none;
    pointer-events: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
}
</style>
